import { render, staticRenderFns } from "./ModalsContainer.vue?vue&type=template&id=f2c0cf6e&"
import script from "./ModalsContainer.vue?vue&type=script&lang=js&"
export * from "./ModalsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports